export class ScrollCTAInitializer {
	init = () => {
		const scrollCTAContainer = document.querySelector<HTMLDivElement>('.product-tag-container .scroll-cta');
		if (scrollCTAContainer == null) return;

		this.handleScrollCTA(scrollCTAContainer);
	};

	private handleScrollCTA(scrollCTAContainer: HTMLDivElement) {
		const scrollStartPos = 0;
		const scrollEndPos = 500;

		window.addEventListener('scroll', () => {
			if (window.scrollY > scrollStartPos && window.scrollY < scrollEndPos) {
				const adaptedNumber = this.mapRange(window.scrollY, scrollStartPos, scrollEndPos, 1, 0);
				scrollCTAContainer.style.opacity = adaptedNumber + '';

				const transformValue = this.mapRange(window.scrollY, scrollStartPos, scrollEndPos, 0, 70);
				scrollCTAContainer.style.transform = `translate(-50%, -${transformValue}px)`;
			} else if (window.scrollY > scrollEndPos) {
				scrollCTAContainer.style.opacity = '0';
				scrollCTAContainer.style.transform = 'translate(-50%, -70px)';
			} else if (window.scrollY < scrollStartPos) {
				scrollCTAContainer.style.opacity = '1';
				scrollCTAContainer.style.transform = 'translate(-50%, 0px)';
			}
		});
	}

	private mapRange(value: number, inMin: number, inMax: number, outMin: number, outMax: number): number {
		return ((value - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
	}
}
